import { useContext, useState } from 'react';
import Axios from 'axios';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import { Button, Col, Row, Select } from 'antd';
import Switchrs from 'components/inputs/Switchrs';
import { Form, Modal } from 'react-bootstrap';

/**
 * این کامپوننت برای نمایش مدال پیگیری در جدول سفارشات است
 */
const CreateWorkerFromVoluntary = ({
  openModal,
  close,
  workerId,
  orderScheduleId,
}) => {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);

  const [formData, setFormData] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const submit = async () => {
    if (formData?.hasAlternative && !formData?.presenterId) {
      return toaster.error('لطفا نیروی جایگزین را انتخاب کنید.');
    }

    const command = {
      ...formData,
      ignoreFormOrder: formData?.ignoreFormOrders,
      isFavorite: formData?.isFavorites,
      hasAdditionalService: formData?.hasAdditionalServices,
    };

    delete command?.ignoreFormOrders;
    delete command?.isFavorites;
    delete command?.hasAdditionalServices;

    setSubmitLoading(true);

    try {
      let url = '/order/createWorker';

      const response = await Axios.post(
        urldashboard + url,
        JSON.stringify({ ...command, orderScheduleId, workerId }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      toaster.success(response?.data?.message);
      setSubmitLoading(false);
      close();
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
    }
  };

  return (
    <Modal show={openModal} onHide={close}>
      <Modal.Header>
        <Modal.Title>انتخاب نیرو</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: '16px', cursor: 'pointer' }}
          onClick={close}
          aria-hidden='true'
        />
      </Modal.Header>
      <Modal.Body style={{ width: 'auto' }}>
        <Row gutter={20} align={'middle'} className={'mb-3'}>
          <Col span={24}>
            <Switchrs
              label='آیا روز های کاری نیرو نادیده گرفته شود؟'
              name='ignoreFormOrders'
              handelValue={(_, value) =>
                handleChange('ignoreFormOrders', value)
              }
            />
          </Col>
        </Row>
        <Row gutter={20} align={'middle'} className={'mb-3'}>
          <Col span={24}>
            <Switchrs
              label='آیا نیرو مورد علاقه است؟'
              name='isFavorites'
              handelValue={(_, value) => handleChange('isFavorites', value)}
            />
          </Col>
        </Row>
        <Row gutter={20} align={'middle'} className={'mb-3'}>
          <Col span={24}>
            <Switchrs
              label='دارای خدمات اضافی است؟'
              name='hasAdditionalServices'
              handelValue={(_, value) =>
                handleChange('hasAdditionalServices', value)
              }
            />
          </Col>
        </Row>
        <Row gutter={20} align={'middle'} className={'mb-3'}>
          {/* <Col span={24}>
            <Switchrs
              label='آیا نیرو جایگزین است؟'
              name='hasAlternative'
              handelValue={(_, value) => handleChange('hasAlternative', value)}
            />
          </Col> */}
          {/* {formData?.hasAlternative ?
          <Col span={24}>
            <Form.Group>
              <Form.Label>نیروی معرفی‌کننده</Form.Label>
              <Select
                className='basic-single'
                classNamePrefix='select'
                styles={{
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
                onChange={(e) => handleChange('presenterId', e.value)}
                isLoading={arrystate?.length > 0 ? false : true}
                isRtl
                isClearable
                name='presenterId'
                options={[
                  {
                    label: 'نام نیروی جایگزین',
                    options: arrystate,
                  },
                ]}
              />
            </Form.Group>
          </Col> : null} */}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          block
          key='submit'
          loading={submitLoading}
          onClick={() => submit()}
          className='btn btn-primary rounded-0'
        >
          ثبت
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateWorkerFromVoluntary;
